
import { LoadingButton } from '@mui/lab';
import { Box, Dialog, DialogActions, DialogContent, Grid } from '@mui/material';
import { useEffect, useState } from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { StaticDataService } from '../../../Component/Api/StaticData/StaticDataService';
import AppAutoComplete from '../../../Component/Common/Components/FormValidationInputs/AppAutoComplete';
import { ScorecardType, StaticDataModel } from '../../../Component/Model/Dto/StaticData';
import { CustomDialogTitle } from '../../Common/Custom/CustomDialogTitle';
import { yupResolver } from '@hookform/resolvers/yup';
import { ScorecardTypeSelectionSchema } from './CertificateRegistryValidationSchema';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';
import { ScorecardTypes } from '../../../Component/Model/Enum/BEE123Enums';

interface IProps {
    showScorecardTypeSelectionModal: boolean;
    handleCancel: () => void;
    onScorecardTypeSelect: (scorecardType: ScorecardType) => void;
}

export const ScorecardTypeSelectionModal = (props: IProps) => {

    const [showInput, setShowInput] = useState(false);
    const [scorecardTypes, setScorecardTypes] = useState<ScorecardType[]>([]);

    const { control, handleSubmit, formState: { isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver(ScorecardTypeSelectionSchema)
    });

    const handleDataSubmit = async (data: FieldValues) => {
        if(data.customType){
            props.onScorecardTypeSelect({'Id': 0, 'Name': data.customType});
        }
        else{
            props.onScorecardTypeSelect({'Id': +data.scorecardType.Id, 'Name': data.scorecardType.Name});
        }
    }

    const getScorecardTypes = async () => {
        try {
            const response = await StaticDataService.getApplicableBEEScorecardTypes();
            if(response.data && response.data.length > 0){
                response.data.push({'Id': 0, 'Name': 'Other'});
                setScorecardTypes(response.data);
            }
            else{
                setScorecardTypes([]);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const onValueChange = async (data: StaticDataModel) => {
        if(data.Id === 0){
            setShowInput(true);
        }
        else{
            setShowInput(false);
        }
    }

    useEffect(() => {
        getScorecardTypes();
    }, [])


    return (
        <Dialog disableEnforceFocus open={props.showScorecardTypeSelectionModal} onClose={() => { props.handleCancel()}} aria-labelledby="form-dialog-title" maxWidth='md' fullWidth>
            <CustomDialogTitle id="customized-dialog-title" onClose={() => props.handleCancel()} rightMargin={"50px"}>
                Select Scorecard Type
            </CustomDialogTitle>
            <DialogContent>
                <Box>
                    <form id='ScorecardTypeSelectionForm' onSubmit={handleSubmit(handleDataSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} mt={1}>
                                <AppAutoComplete control={control} name="scorecardType" label="Scorecard Types" options={scorecardTypes} size={"small"} onChange={onValueChange} limit={50} />
                            </Grid>
                            <Grid item xs={12} sm={12} mt={1}>
                                {showInput && <AppTextInput control={control} name="customType" label="Enter Scorecard Type Name" size={"small"} />}
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </DialogContent>
            <DialogActions>
                <LoadingButton loading={isSubmitting} variant='contained' type="submit" form='ScorecardTypeSelectionForm' color='primary'>Select</LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
